import { render, staticRenderFns } from "./SampleResultTable.vue?vue&type=template&id=77ae8f65"
import script from "./SampleResultTable.vue?vue&type=script&lang=js"
export * from "./SampleResultTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports